var React = require('react');

function ArrowBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.89491 20.7625C9.44642 21.3807 10.3946 21.4347 11.0128 20.8832C11.631 20.3317 11.685 19.3835 11.1335 18.7653L8.89491 20.7625ZM2.09992 10.8931L0.980632 9.89454C0.473012 10.4635 0.473012 11.3228 0.980632 11.8917L2.09992 10.8931ZM11.1335 3.02097C11.685 2.4028 11.631 1.4546 11.0128 0.903085C10.3946 0.351575 9.44642 0.405608 8.89491 1.02377L11.1335 3.02097ZM23.8999 12.3931C24.7283 12.3931 25.3999 11.7216 25.3999 10.8931C25.3999 10.0647 24.7283 9.39314 23.8999 9.39314L23.8999 12.3931ZM11.1335 18.7653L3.2192 9.89454L0.980632 11.8917L8.89491 20.7625L11.1335 18.7653ZM3.2192 11.8917L11.1335 3.02097L8.89491 1.02377L0.980632 9.89454L3.2192 11.8917ZM23.8999 9.39314L2.09992 9.39314L2.09992 12.3931L23.8999 12.3931L23.8999 9.39314Z","fill":"black"}));
}

ArrowBack.defaultProps = {"width":"26","height":"22","viewBox":"0 0 26 22","fill":"none"};

module.exports = ArrowBack;

ArrowBack.default = ArrowBack;
